import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as ContentfulReducer } from './Contentful'
import { default as ArticleSlugReducer } from './ArticleSlugs'
import { default as HelpArticlesByCategoryReducer } from './HelpArticlesByCategory'
import { default as HelpArticlesBySearchReducer } from './HelpArticlesBySearch'
import { default as MemberCommunicationReducer } from './MemberCommunication'

export * from './Contentful'
export * from './ArticleSlugs'
export * from './HelpArticlesByCategory'
export * from './HelpArticlesBySearch'
export * from './MemberCommunication'
export * from './selectors'

export const types = {
  // contentful api
  ...makeApiTypes('FETCH_CONTENTFUL_DATA', 'contentful'),
  ...makeApiTypes('FETCH_CARE_SEARCH_DATA', 'careSearch'),
  ...makeApiTypes('FETCH_HELP_CATEGORIES_DATA', 'helpCategories'),
  ...makeApiTypes('FETCH_VIDEOS_DATA', 'videos'),
  ...makeApiTypes('FETCH_FEATURED_ARTICLES_DATA', 'featuredArticles'),
  ...makeApiTypes('FETCH_FEATURED_VIDEOS_DATA', 'featuredVideos'),
  ...makeApiTypes('FETCH_RELATED_ARTICLES_DATA', 'relatedArticles'),
  ...makeApiTypes('FETCH_ARTICLE_SLUGS', 'slugs'),
  ...makeApiTypes('FETCH_HELP_SEARCH_DATA', 'articlesBySearch'),
  ...makeApiTypes('FETCH_HELP_ARTICLES_BY_CATEGORY_DATA', 'articlesByCategory'),
  ...makeApiTypes('FETCH_ANNOUNCEMENTS_DATA', 'announcements'),
  ...makeApiTypes('FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES', 'memberComms'),
  CLEAR_CONTENTFUL_DATA: 'contentful/CLEAR_CONTENTFUL_DATA',
  CLEAR_CARE_CONTENTFUL_DATA: 'contentful/CLEAR_CARE_CONTENTFUL_DATA',
  CLEAR_HELP_CATEGORIES_DATA: 'contentful/CLEAR_HELP_CATEGORIES_DATA',
  CLEAR_VIDEOS_DATA: 'contentful/CLEAR_VIDEOS_DATA',
  CLEAR_FEATURED_ARTICLES_DATA: 'contentful/CLEAR_FEATURED_ARTICLES_DATA',
  CLEAR_FEATURED_VIDEOS_DATA: 'contentful/CLEAR_FEATURED_VIDEOS_DATA',
  CLEAR_RELATED_ARTICLES_DATA: 'contentful/CLEAR_RELATED_ARTICLES_DATA',
  CLEAR_ARTICLE_SLUGS: 'contentful/CLEAR_ARTICLE_SLUGS',
  CLEAR_HELP_SEARCH_DATA: 'contentful/CLEAR_HELP_SEARCH_DATA',
  CLEAR_HELP_ARTICLES_BY_CATEGORY_DATA:
    'contentful/CLEAR_HELP_ARTICLES_BY_CATEGORY_DATA',
  CLEAR_ANNOUNCEMENTS_DATA: 'contentful/CLEAR_ANNOUNCEMENTS_DATA',
  CLEAR_MEMBER_COMMS_PRECHECKED_CATEGORIES:
    'contentful/CLEAR_MEMBER_COMMS_PRECHECKED_CATEGORIES',
}

export const initialState = {
  contentful: {
    busy: false,
    error: null,
    entities: {},
  },
  careSearch: {
    busy: false,
    error: null,
    entities: {},
  },
  helpCategories: {
    busy: false,
    error: null,
    entities: {},
  },
  videos: {
    busy: false,
    error: null,
    entities: {},
  },
  featuredArticles: {
    busy: false,
    error: null,
    entities: {},
  },
  featuredVideos: {
    busy: false,
    error: null,
    entities: {},
  },
  relatedArticles: {
    busy: false,
    error: null,
    entities: {},
  },
  articlesBySearch: {
    busy: false,
    error: null,
    isLastPageReached: false,
    last: 0,
    skip: 0,
    entities: [],
  },
  articlesByCategory: {
    busy: false,
    error: null,
    isLastPageReached: false,
    entities: {},
  },
  singleCategory: {
    busy: false,
    error: null,
    entities: [],
  },
  slugs: {
    busy: false,
    error: null,
    entities: {},
  },
  announcements: {
    busy: false,
    error: null,
    entities: {},
  },
  memberComms: {
    busy: false,
    error: null,
    entities: {},
  },
}

export default reduceReducers(
  ContentfulReducer,
  ArticleSlugReducer,
  HelpArticlesByCategoryReducer,
  HelpArticlesBySearchReducer,
  MemberCommunicationReducer,
  // last arg MUST be shared state
  initialState,
)
